import React from 'react';
import { motion } from 'framer-motion';
import { clientLogos } from '../../lib/constants';

const ClientTrustBar = () => {
  return (
    <section className="py-20 bg-neutral-950 overflow-hidden border-y border-white/10">
      <div className="container mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <p className="text-sm uppercase tracking-wider text-neutral-400 font-semibold mb-2">
            Trusted by ambitious startups
          </p>
          <p className="text-neutral-500">
            Join 200+ companies transforming their design
          </p>
        </motion.div>

        <div className="relative -mx-6 px-6 md:-mx-0 md:px-0">
          <div className="absolute left-0 top-0 bottom-0 w-16 md:w-32 bg-gradient-to-r from-neutral-950 to-transparent z-10 pointer-events-none" />
          <div className="absolute right-0 top-0 bottom-0 w-16 md:w-32 bg-gradient-to-l from-neutral-950 to-transparent z-10 pointer-events-none" />

          <motion.div
            className="flex gap-16 items-center"
            animate={{ x: [0, -1200] }}
            transition={{
              duration: 30,
              repeat: Infinity,
              ease: "linear"
            }}
          >
            {[...clientLogos, ...clientLogos, ...clientLogos].map((logo, index) => (
              <motion.div
                key={index}
                className="flex-shrink-0 opacity-50 hover:opacity-100 transition-all duration-300 cursor-pointer"
                whileHover={{ scale: 1.1, y: -4 }}
              >
                <div className="w-40 h-20 bg-white/5 rounded-xl hover:bg-white/10 transition-all flex items-center justify-center border border-white/10 p-4">
                  {logo.src ? (
                    <img
                      src={logo.src}
                      alt={logo.alt}
                      className="max-w-full max-h-full object-contain grayscale hover:grayscale-0 transition-all duration-300"
                    />
                  ) : (
                    <span className="text-white font-bold text-base">
                      {logo.alt}
                    </span>
                  )}
                </div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ClientTrustBar;